/* eslint-disable no-unused-vars */
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import SectionTitle from "../UI/SectionTitle";
import EmptyState from "../UI/EmptyState";
import { DARK_RED, MAIN, st } from "../../constants/styles";
import { useApprovedPrescriptions } from "../../hooks/useProducts";
import { dateFormatter } from "../../helper/helpers";
import { Badge } from "../UI/Badge";
import { prescriptionStatus } from "../UI/StatusText";
import { statusBadge } from "../../constants/status_badges";

const Prescriptions = ({ user }) => {
  const [pageData, setPageData] = useState({
    pageIndex: 0,
    pageSize: 20,
  });
  const navigate = useNavigate();

  const { id } = user ?? {};

  const {
    data = {},
    isPending,
    isError: isPrescriptionError,
    error: prescriptionError,
  } = useApprovedPrescriptions({ ...pageData, customerId: id });

  let { data: prescriptions = [] } = data ?? {};
  let totalItemCount = data?.products?.count ?? 0;
  const totalPages = Math.ceil(totalItemCount / pageData.pageSize);

  const hasNextPage = () => {
    return pageData.pageIndex + 1 >= totalPages;
  };

  //   const statusBadge = (status) => {
  //     switch (status) {
  //       case "Approved":
  //         return Badge.green(status);
  //       case "Substituted":
  //         return Badge.main(status);
  //       case "Unavailable":
  //         return Badge.red(status);
  //       default:
  //         return Badge.blue(status);
  //     }
  //   };

  if (isPending) return <p>Loading Prescriptions...</p>;
  if (isPrescriptionError) {
    return (
      <div>
        <SectionTitle
          title="My Prescriptions"
          subtitle={`${prescriptions.length} prescription item${prescriptions.length !== 1 ? "s" : ""}`}
        />
        <div className="container">
          <p className="text-danger">
            Error getting prescriptions {prescriptionError}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <SectionTitle
        title="My Prescriptions"
        subtitle={`${prescriptions.length} prescription item${prescriptions.length !== 1 ? "s" : ""}`}
      />

      {prescriptions.length === 0 ? (
        <EmptyState
          emoji="📋"
          message="Your Prescriptions is empty. Start ordering items you love!"
          action={
            <Link
              to="/"
              style={{
                ...st.btnMain,
                textDecoration: "none",
                display: "inline-block",
                marginTop: 12,
                padding: "10px 24px",
              }}
            >
              Browse Products
            </Link>
          }
        />
      ) : (
        <div>
          {prescriptions.map((item) => {
            const prescriptionStatusText = prescriptionStatus(item.status);
            return (
              <div
                key={item.id}
                className="border rounded p-13 mb-3 position-relative"
                style={{ background: "#fff" }}
              >
                {/*  */}
                <div className="d-flex gap-3 align-items-start">
                  <span className="table-product__content text-start">
                    <div style={{ marginBottom: 8 }}>
                      {statusBadge(prescriptionStatusText)}
                    </div>
                    <span
                      // to={`/order/detail/${order.id}`}
                      className="text-dark hover-text-main-600 fw-semibold w-100 title mb-5"
                    >
                      Prescription:- {"  "}
                      {item?.prescriptionId}
                    </span>
                    <div className="vstack my-5 gap-6">
                      <span className="py-2">
                        Authorized Qty: {"  "}
                        {item?.authorizedQty}
                      </span>
                      <span className="py-2">
                        Dispensed Qty: {"  "}
                        {item?.dispensedQty}
                      </span>
                      <span className="py-2">
                        Remaining Qty: {"  "}
                        {item?.remainingQty}
                      </span>
                      <span className="text-sm mt-5 mb-0 fw-semibold">
                        Expiry:{" "}
                        {dateFormatter.format(new Date(item?.expiryDate))}
                      </span>
                    </div>
                  </span>
                </div>
              </div>
            );
          })}
          <div className="d-flex justify-content-start mt-30">
            <div className="hstack gap-5">
              <button
                className="btn btn-sm page-link h-20 w-44 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100 hover-bg-main-600 hover-text-white transition-1"
                disabled={pageData.pageIndex === 0}
                onClick={() =>
                  setPageData((prevData) => ({
                    ...prevData,
                    pageIndex: prevData.pageIndex - 1,
                  }))
                }
              >
                <i className="ph-bold ph-arrow-left" />
              </button>
              <button
                className={`btn btn-sm page-link h-40 w-64 flex-center text-md rounded-8 fw-medium text-neutral-600 border border-gray-100 page-item active`}
                disabled
              >
                {(pageData.pageIndex + 1).toString().padStart(2, "0")}
              </button>
              <button
                className="btn btn-sm page-link h-20 w-44 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100 hover-bg-main-600 hover-text-white transition-1"
                disabled={hasNextPage()}
                onClick={() =>
                  setPageData((prevData) => ({
                    ...prevData,
                    pageIndex: prevData.pageIndex + 1,
                  }))
                }
              >
                <i className="ph-bold ph-arrow-right" />
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Prescriptions;
